<app-user-header class="d-md-none"></app-user-header> 
<div class="row m-0 h-100 row-container"> 



  <div class="col-formed-side pe-0 ps-0 section-side-nav h-100 d-none d-md-block">
    <app-sidebar></app-sidebar>
  </div>
  <div class="col-formed-main wrap-container p-0">

    <div class="big-area big-area-padding">
      <div class="col-12 margin-20">

        <div class="pointer" (click)="goBack()">
            <p class="semiboldtextblue16 mb-0"><i class="fal normaltextblue16 fa-chevron-left icon-blue me-2"></i>Takaisin</p>
        </div>
</div>

<div class="col-12 row m-0">
  <div class="col-8 ps-0 pe-0 formed-msg-card wrapper-height">
    <div class="col-12  h-100 p-0" id="main-chat-container">
      <div class="col-12 row m-0 chat-header p-0">
          <div class="col-8 ps-4 col-md-10 name-container">
              <ng-container *ngIf="currentActiveUser">
                  <p class="mb-0 mt-3 semiboldtextblue16">{{currentActiveUser.firstName}} ({{currentActiveUser['mdType']['name_fi']}})</p>
              </ng-container>
          </div>
      </div>
      <div class="chat-window-main-container" #chatMessageContainer>
        <div class="msg-wrapper">
          <ng-container *ngIf="messageList">

            <ng-container *ngFor="let msg of messageList.messages">
                <!-- IF Customer sends message -->
                <div class="col-12 no-padding mt-2" *ngIf="msg.to == currentUserId">
                    <div class="col-md-12 p-0">
                    <div class="row m-0">

      
                      <div class="col-10 col-md-6 col-lg-6 col-xl-5 p-0 mt-3 ms-2 me-2 mb-0">
                        <div class="d-flex justify-content-start p-0">
                          <div class="d-flex align-items-end">
                            <div class="img-container-cust">
                              <img src="{{employerData.logo}}" class="rounded-circle" width="40" height="40" alt="">
                            </div>
                          </div>
                        <div class="text-message ms-2 text-message-left-doctor whitespace-preline">
    
    
                          <div >
                            <div class="body2 break-word text-container">
                                <p class="normaltextgray70016 mb-1">{{msg.message}}</p>
                                <div class="d-flex justify-content-end ps-4">
                                  <p class="text-message-time-left pe-2  mb-0">{{msg.createdDate | chatTimeIndicator}}</p>
                                    <ng-container *ngIf="msg.reciever_has_read">
                                      <img src="../../assets/icons/message_is_read_gray_bg.svg">
                                    </ng-container>
                                </div>
                            </div>
                          </div>
    
    
                        </div>
                      </div>
                      </div>
                      <div class="col-1 col-lg-5 col-xl-6"></div>
                    </div>
                  </div>
                  <div class="col-12 p-0 m-0 row ">
    
<!--                         <p class="text-message-time-left mt-2  mb-0">{{msg.createdDate | chatTimeIndicator}}</p>
-->        
                  </div>
                  </div>
                  <!-- If coach sends message -->
                  <div class="col-md-12 pe-2 mb-2 mt-2" *ngIf=" msg.to != currentUserId ">
                    <div class="row m-0">
                      <div class="col-md-2 col-3">
                        <p class="d-none">To take some space</p>
                      </div>
                      <div class="col-md-10 col-9 p-0">
                        <div class="d-flex justify-content-end p-0">
                          <div class="text-message text-message-right whitespace-preline me-2">
                              
                              <p class="normaltextblue70016 mb-1 break-word">{{msg.message }}</p>
                              <div class="d-flex justify-content-end ps-0">
                                <p class="text-message-time pe-2  mb-0">{{msg.createdDate | chatTimeIndicator}}</p>
                                  <ng-container *ngIf="msg.reciever_has_read">
                                    <img src="../../assets/icons/message_is_read_gray_bg.svg">
                                  </ng-container>
                              </div>
    
<!--                                 <p class="text-message-time text-end">{{msg.createdDate | chatTimeIndicator}}</p>
-->        
                          </div>
                          <div class="d-flex align-items-end">
                            <div class="img-container">
                              <img src="{{employerData.logo}}" class="rounded-circle" width="40" height="40" alt="">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 m-0 ">
                  </div>
                  </div>
            </ng-container>
        </ng-container>
        </div>


      </div>

      <div *ngIf="currentActiveUser">
          <div class="row col-12 reply me-0 ms-0 mt-4 col-12 p-0 pt-1 pb-1 ps-2" >
              
            <div class="col-9 ps-2 reply-main ps-0 pe-0 mt-2">
              <textarea class="send-message-input" autocomplete="off" rows="1" (keydown)="autoTextarea($event)" id="comment" placeholder="Kirjoita viestisi tähän..."
               ></textarea>
            </div>
            <div class="col-3 col-md-3 d-flex justify-content-center  mt-1 mt-md-1">
              <!-- <button class="send-btn" (click)="OnSendReply($event)">Lähetä</button> -->
              <div class="send-btn-container pointer text-center mt-1" (click)="OnSendReply($event)">
                <div class="d-flex align-items-center">
                  <i class="far fa-paper-plane icon-white send-icon"></i>
                  <p class="normaltextwhite14 ms-3 mb-0">Lähetä</p>
                </div>
              </div>
              <!-- <i class="fa fa-send fa-2x" aria-hidden="true" (click)="OnSendReply($event)"></i> -->
            </div>
  
        </div>
      </div>


  </div>
  </div>
  <div class="col-4 pe-0">
    <div class=" sec-height">
      <div class="formed-msg-card" *ngIf="openingData">
        <div class="p-4">
          <p class="formed-sub-title">Työpaikan tiedot</p>
          <div class="card h-100 formed-shadow">
            <div class="card-body p-0">
                <div class="col-12">
                    <div class="formed-blue-bg pt-3 pb-2 ps-4 pe-4">
                        <div class="col-12 d-flex justify-content-between">
                            <div class="d-flex" *ngIf="openingData['mdType']">
                                <div *ngIf="openingData.mdType.id == 1001">
                                    <img src="../../assets/images/formed_blur.jpg" class="rounded-circle" width="50" height="50" alt="">
                                </div>
                                <div *ngIf="openingData.mdType.id == 1002">
                                    <img src="../../assets/images/formed_blur.jpg" class="rounded-circle" width="50" height="50" alt="">
                                </div>
                                <div *ngIf="openingData.mdType.id == 1003">
                                    <img src="../../assets/images/formed_blur.jpg" class="rounded-circle" width="50" height="50" alt="">
                                </div>
                                <div *ngIf="openingData.mdType.id == 1004">
                                    <img src="../../assets/images/nurse_favicon.png" class="rounded-circle" width="50" height="50" alt="">
                                </div>
                                <div *ngIf="openingData.mdType.id == 1005">
                                    <img src="../../assets/images/formed_blur.jpg" class="rounded-circle" width="50" height="50" alt="">
                                </div>
                                <div *ngIf="openingData.mdType.id == 1006">
                                    <img src="../../assets/images/dentist_favicon.png" class="rounded-circle" width="50" height="50" alt="">
                                </div>
                                <div *ngIf="openingData.mdType.id == 1007">
                                    <img src="../../assets/images/formed_blur.jpg" class="rounded-circle" width="50" height="50" alt="">

                                </div>
                                <div *ngIf="openingData.mdType.id == 1008">
                                    <img src="../../assets/images/formed_blur.jpg" class="rounded-circle" width="50" height="50" alt="">

                                </div>
                                <div *ngIf="openingData.mdType.id == 1010">
                                    <img src="../../assets/images/formed_blur.jpg" class="rounded-circle" width="50" height="50" alt="">

                                </div>
                        </div>

                        <div class="views-cont">
                            <div class="views-bg-blue pt-1 ps-3 pe-3 pb-1">
                                <div class="d-flex align-items-center justify-content-center h-100">
                                    <i class="far fa-eye pe-2 white-icon"></i>
                                    <p class="mb-0 normaltextwhite16">{{openingData.views_number}}</p>

                                </div>
                            </div>
                        </div>
                        </div>
                        <div class="col-12 pt-2">
                            <div class="">
                                <p class="semibolddeepbluetext16 mb-0">{{openingData.mdType.name_fi}} </p>
                                <p class="normaltextblue16 mb-0">{{openingData.subGroup.businessName}}</p>
                               
                            </div>
                        </div>
                    </div>
                    <div class="ps-3 mt-3 pe-3">
                        <div class="formed-bg">
                            <div class=" justify-content-center">
                                <div class="d-flex justify-content-center align-items-center">
                                    <i class="fal fa-hand-paper pe-2 blue-icon"></i>
                                    <p class="mb-0 semiboldtextblue14">Kiinnostuneet</p>
                                    <p class="mb-0 formed-sub-title ps-3">{{openingData.applicants_number}}</p>

                                </div>
                                <div class="d-flex justify-content-center mt-2">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="media-body col-12">
                        
                    <div class="col-12 mt-3">
                        <p class="mb-1 normaltextgray14 text-center">Haku päättyy: <span *ngIf="openingData.application_ends">{{openingData.application_ends | formateDate}}</span> </p>

                    </div>
                    </div>
                    <div class="mt-3 ps-3 pe-3 pb-3 text-center d-flex justify-content-center col-12">
                        <button type="button" routerLink="/{{businessID}}/openings/single-opening/{{openingData._id}}" class="btn btn-formed-main-blue w-100">Tiedot</button>
                    </div>
                </div>
            </div>
        </div>

        </div>
      </div>
<!--       <div class="formed-msg-card mt-4">
        <div class="p-4">
          <p class="formed-sub-title">Lukemattomat viesti</p>
          <div class="" *ngIf="unreadMessages.length == 0; else messages_are_not_read_content">
            <p class="text-center normaltextblue30016 mt-4">Lukemattomat viestit tulevat tähän</p>
            <div class="text-center">
              <img src="../../assets/icons/no_messages.svg">
            </div>
            <div class="btn-container d-flex justify-content-center mt-4">
              <button class="btn btn-formed-main-blue w-75" routerLink="/{{businessID}}/messages">Näytä kaikki</button>
            </div>
          </div>
          <ng-template #messages_are_not_read_content>
            <ul class="formed-greenlist p-0">
              <li class="formed-list green-list pointer"  routerLink="/{{businessID}}/messages/message/{{data._id}}" *ngFor="let data of unreadMessages">
                <div class="col-12 row me-0 ms-0">
                  <div class="col-2 ps-0">
                    <div class="img-container-green me-4">
                      <div class="" *ngIf="data && data.user && data.user.profileImage; else no_logo">
                        <img src="{{data.user.profileImage}}" class="rounded-circle" width="40" height="40" alt="">
                      </div>
                      <ng-template #no_logo>
                        <img src="../../assets/images/formed_blur.jpg" class="rounded-circle" width="40" height="40" alt="">
                      </ng-template>
                    </div>
                  </div>
                  <div class="col-10">
                    <div class="d-flex justify-content-between">
                      <div class="d-flex">
                        <p class="mb-0 semiboldgreen70016">{{data.user.firstName}}</p>
                      </div>
                      <div class="d-flex">
                        <p class="mb-0 normaltextgreen60014">{{data.messages[0]['createdDate'] | chatTimeIndicator}}</p>
                      </div>
                    </div>
                    <div class="d-flex justify-content-between">
                      <div class="d-flex">
                        <p class="mb-0 semiboldtextgray50014">{{data.messages[0].message | truncate : 50 : false}}</p>
                      </div>
                      <div class="d-flex">
  
                        <p class="mb-0 semiboldtextblue16">{{data.unreadMessages}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <div class="btn-container d-flex justify-content-center mt-4">
              <button class="btn btn-formed-main-blue w-75" routerLink="/{{businessID}}/messages">Näytä kaikki</button>
            </div>
          </ng-template>
        </div>
      </div> -->
    </div>
  </div>
  </div>


    </div>
  </div>
</div>
